/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignFormRequest
 */
export interface AssignFormRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignFormRequest
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignFormRequest
     */
    machineId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignFormRequest
     */
    assignedOperatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignFormRequest
     */
    dueAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignFormRequest
     */
    workPackNo?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignFormRequest
     */
    taskName?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignFormRequest
     */
    siteName?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignFormRequest
     */
    companyName?: string;
}

/**
 * Check if a given object implements the AssignFormRequest interface.
 */
export function instanceOfAssignFormRequest(value: object): value is AssignFormRequest {
    return true;
}

export function AssignFormRequestFromJSON(json: any): AssignFormRequest {
    return AssignFormRequestFromJSONTyped(json, false);
}

export function AssignFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignFormRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'assignedOperatorId': json['assignedOperatorId'] == null ? undefined : json['assignedOperatorId'],
        'dueAt': json['dueAt'] == null ? undefined : json['dueAt'],
        'workPackNo': json['workPackNo'] == null ? undefined : json['workPackNo'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'siteName': json['siteName'] == null ? undefined : json['siteName'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
    };
}

export function AssignFormRequestToJSON(value?: AssignFormRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'templateId': value['templateId'],
        'machineId': value['machineId'],
        'assignedOperatorId': value['assignedOperatorId'],
        'dueAt': value['dueAt'],
        'workPackNo': value['workPackNo'],
        'taskName': value['taskName'],
        'siteName': value['siteName'],
        'companyName': value['companyName'],
    };
}

